<template lang="pug">
	div( style="width:100%")
		v-card(outlined)
			v-toolbar(dense)
				v-btn-toggle(dense color="grey" group)
					//- v-btn(@click="addPhoto" icon)
					//- 	v-icon mdi-format-bold
					//- v-btn(@click="addPhoto" icon)
					//- 	v-icon mdi-format-italic
					v-btn(@click="addPhoto" icon)
						v-icon(small) image
			v-textarea(v-model="markdown" ref="reply" solo flat hide-details rows="8" style="margin-top:1px")
		client-only
			.drop-active(v-show="false")
				file-upload(
					:input-id="Math.floor(Math.random() * 1000000000).toString()"
					:post-action="uploadUrl"
					:extensions="['gif', 'jpg', 'jpeg', 'png', 'webp']"
					accept="image/png,image/gif,image/jpeg,image/webp"
					:multiple="true"
					drop="#forum-content-input"
					:drop-directory="true"
					v-model="uploadFiles"
					ref="forum-content-input-upload"
					:dropActive="true"
					@input-file="inputFile")
						v-btn(ref="forum-content-input-upload-button") upload
			v-row(v-if="uploadProgressShow")
				v-col uploading {{uploadProgressValue}}%
				v-col
					v-progress-linear(indeterminate :value="uploadProgressValue" color='primary')
</template>

<script>
import gql from 'graphql-tag';
import FileUpload from 'vue-upload-component';

const getUploadUrlQuery = gql`
	query getUploadUrl($bucket: String!) {
		uploadUrl(bucket: $bucket)
	}
`;

export default {
	name: 'MdEditor',
	components: { FileUpload },
	props: {
		value: {
			type: Object,
			default: () => {
				return { markdown: '' };
			}
		},
		editorRef: {
			type: String,
			default: 'markdown'
		}
	},
	async fetch() {
		await this.$graphClient
			.query({
				query: getUploadUrlQuery,
				variables: {
					bucket: 'forum'
				}
			})
			.then(({ data }) => {
				this.uploadUrl = this.$env.UPLOAD_URL + data.uploadUrl;
			});
	},
	data() {
		return {
			markdown: '',
			media: {},
			reference: null,
			uploadProgressShow: false,
			uploadProgressValue: 0,
			uploadFiles: [],
			uploadUrl: '',
			isUploading: false
		};
	},
	watch: {
		value: {
			handler(value) {
				if (value) {
					this.markdown = value.markdown || '';
					// if (this.$refs[this.editorRef])
					// 	this.$refs[this.editorRef].simplemde.codemirror.focus();
				}
			},
			deep: true
		}
	},
	created() {
		if (this.value) {
			this.markdown = this.value.markdown;
		}
		this.$watch(
			vm => [vm.markdown, vm.media].join(),
			function () {
				this.$emit('input', { markdown: this.markdown, media: this.media });
			}
		);
	},
	methods: {
		focusTextArea() {
			this.$refs.reply.focus();
		},
		addPhoto() {
			const input = this.$refs['forum-content-input-upload'].$el.querySelector(
				'input'
			);

			input.onclick = null;
			input.click();
		},
		inputFile(newFile, oldFile) {
			this.$emit('is-uploading', newFile.active);
			let fileFind, fileReplace;

			if (newFile && !oldFile) {
				this.uploadProgressShow = true;
				this.$refs['forum-content-input-upload'].active = true;
				this.value.markdown += `![uploading: ${newFile.name}]()`;
			}

			if (newFile && oldFile) {
				this.uploadProgressValue = newFile.progress;
			}

			if (newFile && oldFile && !newFile.active && oldFile.active) {
				if (newFile.error === '') {
					fileFind = `![uploading: ${newFile.name}]()`;
					fileReplace = `![](${newFile.response.results[0].url})`;

					if (!this.media.photos) {
						this.media.photos = [];
					}

					this.media.photos.push({
						alt: null,
						url: newFile.response.results[0].url
					});
				} else {
					fileFind = `![uploading: ${newFile.name}]()`;
					fileReplace = '';

					this.$toast.error(this.$t('error:image-upload-failed'));
				}
				this.$nextTick(() => {
					this.value.markdown = this.value.markdown.replace(
						fileFind,
						fileReplace
					);
				});

				this.uploadByButton = false;

				setTimeout(() => {
					this.uploadProgressShow = false;
				}, 200);
			}
		}
	}
};
</script>
